"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalFooter = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _clamp = require("../utils/_clamp");
var _constants = require("../utils/constants");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _Modal = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
var _excluded = ["children", "className", "contentRef", "resizable", "updateStyle", "modalContentId"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-modal';
var RESIZE_STEP_SIZE = 16;
var addChildProps = function addChildProps(classnames, _ref, childProps) {
  var displayName = _ref.displayName;
  if (displayName === 'Button') {
    var _context;
    return {
      className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__button"), (0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "__button--")).call(_context, childProps.size), childProps.size && childProps.size !== 'lg'), childProps.className)
    };
  }
  return {};
};
var ModalFooter = exports.ModalFooter = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _contentRef$current;
  var children = props.children,
    className = props.className,
    contentRef = props.contentRef,
    resizable = props.resizable,
    updateStyle = props.updateStyle,
    modalContentId = props.modalContentId,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var _useState3 = (0, _react.useState)({
      width: 0,
      height: 0
    }),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    position = _useState4[0],
    setPosition = _useState4[1];
  var dialogClientRect = contentRef === null || contentRef === void 0 || (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getBoundingClientRect();
  var getDialogNode = function getDialogNode() {
    var _document;
    return (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById(modalContentId);
  };
  var contentClientRect = function contentClientRect() {
    var _getDialogNode;
    return (_getDialogNode = getDialogNode()) === null || _getDialogNode === void 0 ? void 0 : _getDialogNode.getBoundingClientRect();
  };
  var getDialogWidth = function getDialogWidth() {
    var _getDialogNode2;
    return ((_getDialogNode2 = getDialogNode()) === null || _getDialogNode2 === void 0 ? void 0 : _getDialogNode2.offsetWidth) || (dialogClientRect === null || dialogClientRect === void 0 ? void 0 : dialogClientRect.width) || 0;
  };
  var getDialogHeight = function getDialogHeight() {
    var _getDialogNode3;
    return ((_getDialogNode3 = getDialogNode()) === null || _getDialogNode3 === void 0 ? void 0 : _getDialogNode3.offsetHeight) || (dialogClientRect === null || dialogClientRect === void 0 ? void 0 : dialogClientRect.height) || 0;
  };
  var getContentTop = function getContentTop() {
    var _contentClientRect;
    return ((_contentClientRect = contentClientRect()) === null || _contentClientRect === void 0 ? void 0 : _contentClientRect.top) || 0;
  };
  var getContentBottom = function getContentBottom() {
    var _contentClientRect2;
    return ((_contentClientRect2 = contentClientRect()) === null || _contentClientRect2 === void 0 ? void 0 : _contentClientRect2.bottom) || 0;
  };
  var getContentLeft = function getContentLeft() {
    var _contentClientRect3;
    return ((_contentClientRect3 = contentClientRect()) === null || _contentClientRect3 === void 0 ? void 0 : _contentClientRect3.left) || 0;
  };
  var getContentRight = function getContentRight() {
    var _contentClientRect4;
    return ((_contentClientRect4 = contentClientRect()) === null || _contentClientRect4 === void 0 ? void 0 : _contentClientRect4.right) || 0;
  };
  var getContentHeight = function getContentHeight() {
    var _contentClientRect5;
    return ((_contentClientRect5 = contentClientRect()) === null || _contentClientRect5 === void 0 ? void 0 : _contentClientRect5.height) || 0;
  };
  var getContentWidth = function getContentWidth() {
    var _contentClientRect6;
    return ((_contentClientRect6 = contentClientRect()) === null || _contentClientRect6 === void 0 ? void 0 : _contentClientRect6.width) || 0;
  };
  var classnames = _bind.default.bind(_Modal.default);
  var footerClasses = classnames("".concat(CSS_BLOCK, "__footer"), className);
  var minResizableWidth = Math.max((resizable === null || resizable === void 0 ? void 0 : resizable.minWidth) || 0, 200);
  var maxResizableWidth = Math.min((resizable === null || resizable === void 0 ? void 0 : resizable.maxWidth) || 999999, 99999);
  var minResizableHeight = Math.max((resizable === null || resizable === void 0 ? void 0 : resizable.minHeight) || 0, 200);
  var maxResizableHeight = Math.min((resizable === null || resizable === void 0 ? void 0 : resizable.maxHeight) || 999999, 99999);
  var onMouseDown = (0, _react.useCallback)(function (e) {
    var _e$persist;
    e === null || e === void 0 || (_e$persist = e.persist) === null || _e$persist === void 0 || _e$persist.call(e);
    if (e.button !== 0) {
      return;
    }
    if (typeof (resizable === null || resizable === void 0 ? void 0 : resizable.onDragStart) === 'function') {
      resizable.onDragStart(e);
    }
    setIsDragging(true);
    setPosition(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        startX: e.pageX,
        startY: e.clientY,
        startWidth: getDialogWidth(),
        startHeight: getDialogHeight()
      });
    });
  });
  var onKeyDown = function onKeyDown(e) {
    var _e$persist2;
    e === null || e === void 0 || (_e$persist2 = e.persist) === null || _e$persist2 === void 0 || _e$persist2.call(e);
    var resizeStepSize = e.shiftKey ? 5 * RESIZE_STEP_SIZE : RESIZE_STEP_SIZE;
    switch (e.keyCode) {
      case _keycode.default.codes.left:
        {
          e.preventDefault();
          var reducedWidth = getDialogWidth() - resizeStepSize;
          reducedWidth = (0, _clamp.clamp)(reducedWidth, minResizableWidth, maxResizableWidth);
          updateStyle === null || updateStyle === void 0 || updateStyle({
            width: "".concat(reducedWidth, "px"),
            height: "".concat(getDialogHeight(), "px")
          });
          setPosition(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              width: reducedWidth
            });
          });
          break;
        }
      case _keycode.default.codes.right:
        {
          e.preventDefault();
          var increasedWidth = getDialogWidth() + Math.min(resizeStepSize, window.innerWidth - getContentRight());
          increasedWidth = (0, _clamp.clamp)(increasedWidth, minResizableWidth, maxResizableWidth);
          updateStyle === null || updateStyle === void 0 || updateStyle({
            width: "".concat(increasedWidth, "px"),
            height: "".concat(getDialogHeight(), "px")
          });
          setPosition(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              width: increasedWidth
            });
          });
          break;
        }
      case _keycode.default.codes.up:
        {
          e.preventDefault();
          var reducedHeight = getDialogHeight() - resizeStepSize;
          reducedHeight = (0, _clamp.clamp)(reducedHeight, minResizableHeight, maxResizableHeight);
          updateStyle === null || updateStyle === void 0 || updateStyle({
            height: "".concat(reducedHeight, "px"),
            width: "".concat(getDialogWidth(), "px")
          });
          setPosition(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              height: reducedHeight
            });
          });
          break;
        }
      case _keycode.default.codes.down:
        {
          e.preventDefault();
          var increasedHeight = getDialogHeight() + Math.min(resizeStepSize, window.innerHeight - getContentBottom());
          increasedHeight = (0, _clamp.clamp)(increasedHeight, minResizableHeight, maxResizableHeight);
          updateStyle === null || updateStyle === void 0 || updateStyle({
            height: "".concat(increasedHeight, "px"),
            width: "".concat(getDialogWidth(), "px")
          });
          setPosition(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              height: increasedHeight
            });
          });
          break;
        }
      default:
    }
    if (typeof (resizable === null || resizable === void 0 ? void 0 : resizable.onKeyDown) === 'function') {
      resizable.onKeyDown(e);
    }
  };
  (0, _react.useEffect)(function () {
    if (!resizable) return;
    // update dialog size if resizable values change
    var width = "".concat((0, _clamp.clamp)(resizable === null || resizable === void 0 ? void 0 : resizable.width, minResizableWidth, maxResizableWidth), "px") || getDialogWidth();
    var height = "".concat((0, _clamp.clamp)(resizable === null || resizable === void 0 ? void 0 : resizable.height, minResizableHeight, maxResizableHeight), "px") || getDialogHeight();
    updateStyle === null || updateStyle === void 0 || updateStyle({
      width: width,
      height: height
    });
  }, [resizable === null || resizable === void 0 ? void 0 : resizable.width, resizable === null || resizable === void 0 ? void 0 : resizable.height, minResizableWidth, maxResizableWidth, minResizableHeight, maxResizableHeight]);
  var clip = function clip() {
    var width = getDialogWidth();
    var height = getDialogHeight();
    if (getContentTop() + getContentHeight() > window.innerHeight) {
      height = (0, _clamp.clamp)(window.innerHeight - getContentTop(), minResizableHeight, window.innerHeight);
      height = "".concat(height, "px");
    }
    if (getContentLeft() + getContentWidth() > window.innerWidth) {
      width = (0, _clamp.clamp)(window.innerWidth - getContentLeft(), minResizableWidth, window.innerWidth);
      width = "".concat(width, "px");
    }
    updateStyle === null || updateStyle === void 0 || updateStyle({
      width: width,
      height: height
    });
  };
  (0, _useUniversalLayoutEffect.default)(function () {
    if (!resizable) return function () {};
    // update dialog size if children/content change(s).
    // This ensures that if initial dimensions are not set
    // and the the modal contents go beyond
    // the visible screen, we reset it to fit the screen size.
    var clippingTimer = setTimeout(function () {
      clip();
    }, 300);
    return function () {
      clearTimeout(clippingTimer);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!resizable) return;
    // update dialog size if children/content change(s).
    // This ensures that if initial dimensions are not set
    // and the new children/content causes the modal to go beyond
    // the visible screen, we reset it to fit the screen size.
    clip();
  }, [children]);
  (0, _react.useEffect)(function () {
    var onMouseMove = function onMouseMove(e) {
      var _e$persist3;
      e === null || e === void 0 || (_e$persist3 = e.persist) === null || _e$persist3 === void 0 || _e$persist3.call(e);
      var x = e.pageX;
      var y = e.clientY;
      var newWidth = position.startWidth + x - position.startX;
      var maxWidth = Math.min(maxResizableWidth, window.innerWidth - getContentLeft());
      newWidth = (0, _clamp.clamp)(newWidth, minResizableWidth, maxWidth);
      var newHeight = position.startHeight + y - position.startY;
      var maxHeight = Math.min(maxResizableWidth, window.innerHeight - getContentTop());
      newHeight = (0, _clamp.clamp)(newHeight, minResizableHeight, maxHeight);
      updateStyle === null || updateStyle === void 0 || updateStyle({
        height: "".concat(newHeight, "px"),
        width: "".concat(newWidth, "px")
      });
    };
    var onMouseUp = function onMouseUp(e) {
      var _e$persist4;
      e === null || e === void 0 || (_e$persist4 = e.persist) === null || _e$persist4 === void 0 || _e$persist4.call(e);
      setIsDragging(false);
      if (typeof (resizable === null || resizable === void 0 ? void 0 : resizable.onDragEnd) === 'function') {
        resizable.onDragEnd(e);
      }
    };
    if (isDragging) {
      document.addEventListener('mouseup', onMouseUp);
      document.addEventListener('mousemove', onMouseMove);
    }
    return function () {
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
    };
  }, [isDragging, position, resizable]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-bind
    _react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
      value: addChildProps.bind(null, classnames)
    }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
      className: footerClasses,
      ref: ref
    }), children, resizable && /*#__PURE__*/_react.default.createElement("span", {
      "aria-label": resizable.handleLabel,
      onMouseDown: onMouseDown,
      onKeyDown: onKeyDown,
      role: "button",
      tabIndex: "0",
      className: classnames("".concat(CSS_BLOCK, "__resize-handle"))
    })))
  );
});
ModalFooter.displayName = 'Modal.Footer';
ModalFooter.propTypes = {
  /** Content of the modal footer. */
  children: _propTypes.default.node,
  /** Custom classes to add to the footer’s `<div>` tag. */
  className: _propTypes.default.string,
  /** @ignore */
  contentRef: _propTypes.default.object,
  /** @ignore */
  resizable: _propTypes.default.shape({
    handleLabel: _propTypes.default.string.isRequired,
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    maxHeight: _propTypes.default.number,
    maxWidth: _propTypes.default.number,
    minHeight: _propTypes.default.number,
    minWidth: _propTypes.default.number,
    onDragStart: _propTypes.default.func,
    onDragEnd: _propTypes.default.func,
    onKeyDown: _propTypes.default.func
  }),
  /** @ignore */
  updateStyle: _propTypes.default.func,
  /** @ignore */
  modalContentId: _propTypes.default.string
};
var _default = exports.default = ModalFooter;